import { ReactNode } from 'react';
import css from './Sidebar.module.scss';

export const Sidebar = ({ children }: { children: ReactNode }) => (
  <aside className={`${css.page__sidebar} ${css.page__sidebar_left}`}>
    {children}
  </aside>
);
